import { useEffect } from 'react';
import { useAccount } from "../assets/js/ContextProviders/AccountContext";
import { BackendURL } from "../utils/BackendURL";
import axios from 'axios';

export const handleSubmit = async (DataObj) => {

    // event FOR PREVENTING DEFAULT BEHAVIOUR ON SUBMIT:
    if (DataObj.event) {
        DataObj.event.preventDefault();
    }

    let FinalData = {};

    // username FOR KEY Username:
    if (DataObj.username) {
        FinalData['Username'] = DataObj.username;
    }

    // userAcc FOR THE OBJ CONTAINAING USER ACCOUNT DATA:
    if (DataObj.userAcc) {
        for (let key in DataObj.userAcc) {
            FinalData[key] = DataObj.userAcc[key]
        }
    }

    // mergedData FOR THE ALREADY MERGED DATA IN THE FORM OF KEY-VALUE PAIR:
    if (DataObj.mergedData) {
        for (let key in DataObj.mergedData) {
            FinalData[key] = DataObj.mergedData[key];
        }
    }

    // {h1,h2,h3...hn} and {data1,data2,data3...datan} TO MAKE KEYS AND VALUE MANAULLY:
    for (let h in DataObj) {
        if (h.startsWith('h')) {
            let number = h.substring(1);
            for (let data in DataObj) {
                if (data.startsWith('data') && data.endsWith(number)) {
                    FinalData[DataObj[h]] = DataObj[data];
                }
            }
        }
    }

    // {arr1,arr2,arr3...arrn} and {arrh1,arrh2,arrh3...arrhn} TO MAKE KEYS AND VALUE(ARRAYS) MANUALLY:
    // for (let h in DataObj) {
    //     if (h.startsWith('arrh')) {
    //         let number = h.substring(1);
    //         for(let data in DataObj){
    //             if(data.startsWith('arr') && data.endsWith(number)){
    //                 FinalData[DataObj[h]] = DataObj[data];
    //             }
    //         }
    //     }
    // }

    try {
        const res = await axios.post(`${BackendURL}/${DataObj.api}`, FinalData);
        console.log(res.data);
    } catch (error) {
        console.error("Error:", error.message);
    }

};

export const retrieveData = async (Obj) => {
    try {
        if (Obj.var) {
            const apistring = (`${BackendURL}/${Obj.api}/${Obj.var}`)
            console.log(apistring)
            const response = await axios.get(apistring);
            return response.data;
        } else {
            const apistring = (`${BackendURL}/${Obj.api}`)
            console.log(apistring)
            const response = await axios.get(apistring);
            return response.data;
        }
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error; // Rethrow the error to be caught by the caller
    }
};